//
//
//
//
//
//
//

import index from './index';
export default {
  name: 'OnTheJob',
  data: function data() {
    return {};
  },
  components: {
    index: index
  },
  mounted: function mounted() {
    this.$refs.index.setTabTypes(1);
  }
};